module.exports = __webpack_public_path__ + "media/assets/images/icons/resource-generic/file-large-8e97ecc764505d12904f432c7d6d299e.png";